import { jsx } from "react/jsx-runtime";
import { Button, Box, IconChevronRight } from "@zillow/constellation";
function ArrowBlockButton({
  children,
  href,
  target = "_blank",
  ...rest
}) {
  return /* @__PURE__ */ jsx(Button, { as: "a", variant: "secondary", href, target, fluid: true, icon: /* @__PURE__ */ jsx(IconChevronRight, {}), iconPosition: "end", ...rest, children: /* @__PURE__ */ jsx(Box, { sx: {
    flex: 1,
    textAlign: "left"
  }, children }) });
}
export {
  ArrowBlockButton as default
};
